import { Modal } from './Modal';
import { tx } from '../i18n';
import { Secreto } from './piezas';

/**
 * El código de alta, que se ve UNA sola vez (protocolo §1: un solo uso, vence en 7 días).
 * La ventana no se cierra con un clic afuera a propósito: si se pierde, hay que sacar otro.
 */
export function CodigoDeAlta({ codigo, nombre, alCerrar }: { codigo: string; nombre: string; alCerrar: () => void }) {
  return (
    <Modal
      titulo={tx.codigo.para(nombre)}
      alCerrar={alCerrar}
      cerrarAfuera={false}
      pie={
        <button type="button" className="btn prim" onClick={alCerrar}>
          {tx.codigo.guardado}
        </button>
      }
    >
      <p className="alerta" role="alert">
        <b>{tx.codigo.unaSolaVez}</b> {tx.codigo.que}
      </p>
      <Secreto valor={codigo} etiqueta={tx.codigo.titulo} />
      <p className="nota">{tx.codigo.como}</p>
    </Modal>
  );
}
